import $ from "jquery";
import "./../styles/main.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import flatpickr from "flatpickr";
import GLightbox from "glightbox";
import transitionEffect from "./helpers/transitionEffect";
import Cookies from "js-cookie";
require("./disableScroll.js");
function preventScroll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
$.getMultiScripts = function (arr) {
    var _arr = $.map(arr, function (src) {
        return $.getScript(src);
    });
    _arr.push($.Deferred(function (deferred) {
        $(deferred.resolve);
    }));
    return $.when.apply($, _arr);
};
require("jquery.scrollto");
import { carouselWrapper } from "./helpers/CarouselWrapper";
import { sliderWrapper } from "./helpers/SliderWrapper";
$.fn.serializeFormJSON = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        }
        else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
var te = new transitionEffect();
// te.toggle();
var Site = {
    // Plugins
    carousel: carouselWrapper,
    slider: sliderWrapper,
    // Actions
    init: function () {
        Site.global();
    },
    transition: function (response) {
        Site.global();
        Site.scripts(response);
    },
    global: function () {
        Site.carousel();
        Site.slider();
        Site.ui();
        Site.aboutPage();
        if ($("#header_home").length && $(window).width() > 600) {
            var homeTitleContainer_1 = document.querySelector("#header_home .content");
            // Starting by stars
            gsap.from(homeTitleContainer_1, { opacity: 0, delay: 0.5, duration: 0.25, stagger: 0.05, onStart: function () {
                    $(window).scrollTop(0);
                    $('body').addClass("no-scroll");
                } });
            var delay = 1.55;
            var split = new SplitText("#home-title", { type: "chars,words,lines", position: "absolute" });
            $(split.lines).each(function (k, v) {
                var y = k == 0 ? -30 : 30;
                gsap.from(v, { duration: 1, y: y, delay: 0.6, autoAlpha: 0, ease: "power3", stagger: 0.05 });
            });
            var fromAtoB = 0.50;
            var canShowNextStep_1 = false;
            var tenpct = $(window).height() * 0.1;
            setTimeout(function () {
                $('#header_home').addClass("turn");
            }, 1400);
            gsap.from(homeTitleContainer_1, { y: tenpct, duration: fromAtoB, ease: "power3", delay: delay, onStart: function () {
                } });
            gsap.to("#main-header", { delay: delay, opacity: 1, duration: fromAtoB, ease: "power3" });
            gsap.from("#next-generation", { y: 100, autoAlpha: 0, ease: "power3", delay: delay + 0.1, duration: 0.4 });
            var homeSlider_1 = document.querySelector("#header_home .slider");
            gsap.from(homeSlider_1, { delay: delay, y: 100, autoAlpha: 0, duration: fromAtoB, ease: "power3", onComplete: function () {
                    canShowNextStep_1 = true;
                } });
            var alreadyAnimated_1 = false;
            $(window).on("wheel", function (e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            });
            $(window).on("wheel touchstart", function (e) {
                if (!alreadyAnimated_1 && canShowNextStep_1) {
                    gsap.to("#next-generation", { autoAlpha: 0, y: 20, ease: "power3", duration: 0.25 });
                    gsap.to(homeSlider_1, { scale: 1, duration: 0.5, delay: 0.05, onComplete: function () {
                            $("#header_home").removeClass("start");
                            $("body").removeClass("no-scroll");
                        } });
                    gsap.to(homeTitleContainer_1, { opacity: 0, delay: 0.1, duration: 0.5, stagger: 0.05 });
                }
            });
            $(window).scroll(function (e) {
                e.preventDefault();
                var st = $(window).scrollTop();
            });
            // setTimeout(() => {
            // }, 2000);
        }
        var customLightboxHTML = "<div id=\"glightbox-body\" class=\"glightbox-container\">\n            <div class=\"gloader visible\"></div>\n            <div class=\"goverlay\"></div>\n            <div class=\"gcontainer\">\n                <div id=\"glightbox-slider\" class=\"gslider\"></div>\n                <button class=\"gnext gbtn\" tabindex=\"0\" aria-label=\"Next\" data-customattribute=\"example\">{nextSVG}</button>\n                <button class=\"gprev gbtn\" tabindex=\"1\" aria-label=\"Previous\">{prevSVG}</button>\n                </div>\n            </div>";
        // <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>
        var customSlideHTML = "<div class=\"gslide\">\n            <div class=\"gslide-inner-content\">\n                <div class=\"ginner-container\">\n                    <div class=\"gslide-media\">\n                        <div class=\"gclose-wrapper\"><button class=\"gclose gbtn\" tabindex=\"2\" aria-label=\"Close\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 512 512\" xml:space=\"preserve\"><g><g><path d=\"M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z\"></path></g></g><g><g><path d=\"M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z\"></path></g></g></svg></button></div>\n                    </div>\n                    <div class=\"gslide-description\">\n                        <div class=\"gdesc-inner\">\n                            <h4 class=\"gslide-title\"></h4>\n                            <div class=\"gslide-desc\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>";
        var lb = GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false,
            lightboxHTML: customLightboxHTML,
            slideHTML: customSlideHTML
        });
        $("body").on("click", ".gclose.gbtn", function () {
            lb.close();
        });
    },
    aboutPage: function () {
        if ($(".page-template-tpl-about").length) {
            var sections_1 = {
                history: {
                    node: $("#history"),
                    menu: $('li[data-section="#history"]'),
                    progress: $('li[data-section="#history"]').children("span"),
                    offset: { top: $("#history").offset().top, bottom: $("#history").offset().top + $("#history").outerHeight() }
                },
                missions: {
                    node: $("#missions"),
                    menu: $('li[data-section="#missions"]'),
                    progress: $('li[data-section="#missions"]').children("span"),
                    offset: { top: $("#missions").offset().top, bottom: $("#missions").offset().top + $("#missions").outerHeight() }
                },
                // team: {
                //     node: $("#team"),
                //     menu: $('li[data-section="#team"]'),
                //     progress: $('li[data-section="#team"]').children("span"),
                //     offset: { top: $("#team").offset().top, bottom: $("#team").offset().top + $("#team").outerHeight() }
                // },
                explore: {
                    node: $("#explore"),
                    menu: $('li[data-section="#explore"]'),
                    progress: $('li[data-section="#explore"]').children("span"),
                    offset: { top: $("#explore").offset().top, bottom: $("#explore").offset().top + $("#explore").outerHeight() }
                },
                partners: {
                    node: $("#partners"),
                    menu: $('li[data-section="#partners"]'),
                    progress: $('li[data-section="#partners"]').children("span"),
                    offset: { top: $("#partners").offset().top, bottom: $("#partners").offset().top + $("#partners").outerHeight() }
                }
            };
            var navigation_1 = $("#navigation").find("li");
            $(window).scroll(function () {
                var st = $(window).scrollTop();
                if (st < sections_1.history.offset.top - 100) {
                    navigation_1.removeClass("current");
                }
                // if (st > sections.history.offset.top  - 200 && st < sections.map.offset.bottom) {
                for (var item in sections_1) {
                    if (st < sections_1[item].offset.top - 200)
                        sections_1[item].progress.css({ width: "0%" });
                    if (st > sections_1[item].offset.top - 200 && (st < sections_1[item].offset.bottom)) {
                        navigation_1.removeClass("current");
                        sections_1[item].menu.addClass("current");
                        var delta = sections_1[item].offset.bottom - (sections_1[item].offset.top - 100);
                        var path = st - (sections_1[item].offset.top - 200);
                        var n = parseInt(path / delta * 100);
                        sections_1[item].progress.css({ width: (n > 100 ? 100 : (n < 5 ? 0 : n)) + "%" });
                    }
                    if (st > sections_1[item].offset.bottom)
                        sections_1[item].progress.css({ width: "100%" });
                }
                // // history 
                // if (st > sections.history.offset.top && st < sections.history.offset.bottom) {}
                // // missions 
                // if (st > sections.missions.offset.top && st < sections.missions.offset.bottom) {}
                // // team 
                // if (st > sections.team.offset.top && st < sections.team.offset.bottom) {}
                // // partners 
                // if (st > sections.partners.offset.top && st < sections.partners.offset.bottom) {}
                // // map 
                // if (st > sections.map.offset.top && st < sections.map.offset.bottom) {
                // }
                // }
            });
            $(window).trigger("scroll");
            $("#keywords").on("mouseover", "a", function (e) {
                $("#keywords").attr("data-child", $(e.currentTarget).index() + 1);
            });
        }
    },
    eventPage: function () {
        flatpickr(".date-picker", {
            // disableMobile: "true",
            altFormat: "d M Y",
            altInput: true,
            dateFormat: "Ymd",
            onReady: function () {
                if ($('.date-picker.start').val() == "")
                    $(".date-picker.start.flatpickr-input:not([type=hidden])").attr("type", "text");
                if ($('.date-picker.end').val() == "")
                    $(".date-picker.end.flatpickr-input:not([type=hidden])").attr("type", "text");
            },
            disableMobile: true
        });
        var eventsList = $("#events-list");
        var eventType = $("#events-list").attr("data-type");
        var startDate = $('.date-picker.start');
        var endDate = $('.date-picker.end');
        $("body").on("change", '.date-picker.start, .date-picker.end, #eventcategory', function (e) {
            e.preventDefault();
            var formData = $("#filter-form").serializeFormJSON();
            formData.type = eventType;
            formData.startDate = startDate.val();
            formData.endDate = endDate.val();
            $.post("/api/events", formData).done(function (data) {
                eventSystem.replace(data, eventsList);
                $(".ButtonWrapper.more-events").attr("data-paged", "1");
            });
        });
        // $("body").on("focus", '.date-picker.start, .date-picker.end', (e) =>{
        //     $(e.currentTarget).attr("type", "date");
        // });
        // $("body").on("blur", '.date-picker.start, .date-picker.end', (e) =>{
        //     if ($(e.currentTarget).val()=="") {
        //         $(e.currentTarget).attr("type", "text");
        //     }
        // });
        // onfocus="(this.type='date')" onblur="if(this.value==''){this.type='text'}"
        $("#filter-form").on("click", "button", function (e) {
            e.preventDefault();
            var formData = $("#filter-form").serializeFormJSON();
            formData.startDate = startDate.val();
            formData.endDate = endDate.val();
            formData.type = eventType;
            $.post("/api/events", formData).done(function (data) {
                eventSystem.replace(data, eventsList);
                $(".ButtonWrapper.more-events").attr("data-paged", "1");
            });
        });
        $("body").on("click", ".ButtonWrapper.more-events a", function (e) {
            e.preventDefault();
            var paged = parseInt($(e.currentTarget).parent().attr("data-paged"));
            var nextPaged = paged + 1;
            // --
            var formData = $("#filter-form").serializeFormJSON();
            formData.startDate = startDate.val();
            formData.endDate = endDate.val();
            formData.paged = nextPaged;
            formData.type = eventType;
            $.post("/api/events", formData).done(function (data) {
                eventSystem.add(data, eventsList);
                $(e.currentTarget).parent().attr("data-paged", nextPaged);
            });
        });
    },
    ui: function () {
    },
    scripts: function (response) {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
var eventSystem = {
    eventNumbers: 6,
    latestType: "next",
    moreButton: function (data) {
        if (data.events.length < eventSystem.eventNumbers) {
            $(".ButtonWrapper.more-events").hide();
        }
        else {
            $(".ButtonWrapper.more-events").show();
        }
    },
    replace: function (data, eventsList) {
        eventsList.css({ minHeight: eventsList.css("height") });
        var childrenLength = eventsList.children().length;
        console.log(childrenLength, data.events.length);
        if (childrenLength == 0 && data.events.length > 0) {
            $('.no-event').fadeOut(250);
            eventSystem.add(data, eventsList);
        }
        else {
            eventsList.children().each(function (k, v) {
                gsap.to(v, {
                    duration: 0.35,
                    opacity: 0,
                    y: -30,
                    delay: k * 0.20,
                    ease: "Expo.easeInOut"
                }).eventCallback("onComplete", function () {
                    if (childrenLength - 1 == k) {
                        eventsList.children().remove();
                        if (data.events.length == 0) {
                            $('.no-event').fadeIn(250);
                            $(".ButtonWrapper.more-events").hide();
                            eventsList.css({ minHeight: 0 });
                        }
                        else {
                            $('.no-event').fadeOut(250);
                            eventSystem.add(data, eventsList);
                        }
                    }
                });
            });
        }
    },
    add: function (data, eventsList) {
        $.each(data.events, function (k, v) {
            eventsList.append("<li style='opacity: 0; transform: translateY(-30px)'>" + v + "</li>");
            if (k == data.events.length - 1) {
                eventsList.css({ minHeight: 0 });
                eventsList.children().each(function (key, elm) {
                    gsap.to(elm, {
                        duration: 0.35,
                        opacity: 1,
                        y: 0,
                        delay: key * 0.20,
                        ease: "Expo.easeInOut"
                    });
                });
                eventSystem.moreButton(data);
            }
        });
    }
};
// barba.init({
//     views: [
//         {
//             namespace: "about",
//             beforeLeave() { $("body").addClass("forced"); }
//         },
//         {
//             namespace: "events",
//             beforeLeave() { },
//             beforeEnter() {
//                 Site.eventPage();
//             }
//         },
//         {
//             namespace: "room",
//             beforeLeave() { $("body").addClass("forced"); }
//         },
//         {
//             namespace: "booking",
//             beforeLeave() { 
//                 $("body").addClass("forced"); 
//             }
//         },
//         {
//         namespace: 'explore.details',
//         beforeEnter() {
//         },
//         afterEnter() {            
//             let revealContainers = document.querySelectorAll(".reveal-image");
//             revealContainers.forEach((container) => {
//                 let image = container.querySelector("img");
//                 let tl = gsap.timeline({
//                     scrollTrigger: {
//                         trigger: container,
//                         toggleActions: "restart none none reset"
//                     }
//                 });
//                 tl.set(container, { autoAlpha: 1 });
//                 tl.from(container, {
//                     duration: 1,
//                     xPercent: -100,
//                     ease: "Expo.easeInOut"
//                 });
//                 tl.from(image,{
//                     duration: 1,
//                     xPercent: 100,
//                     scale: 1.3,
//                     delay: -1,
//                     ease: "Expo.easeInOut"
//                 });
//             });
//         }
//     }],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             te.toggle().eventCallback("onComplete", () => {
//                 gsap.to(current.container, {
//                     opacity: 0
//                 }).eventCallback("onComplete", () => {
//                     done();
//                 });
//             });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             });
//             te.toggle().eventCallback("onComplete", () => {
//                 te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
// require('./woocommerce/Global');
// require ('./helpers/CookieConsent');
$(document).ready(function () {
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        $("body").addClass("safari");
    }
    if ($(window).width() > 1100) {
        var timeOut_1;
        $('.language-wrapper').on("touchstart", function () {
            if (!$('.language-wrapper').hasClass("open")) {
                clearTimeout(timeOut_1);
                $('.language-wrapper').addClass("open");
            }
            else {
                $('.language-wrapper').addClass("closing");
                timeOut_1 = setTimeout(function () {
                    $('.language-wrapper').addClass("close");
                    setTimeout(function () { $('.language-wrapper').removeClass("open closing close"); }, 400);
                }, 150);
            }
        });
        $('.language-wrapper').hover(function () {
            clearTimeout(timeOut_1);
            $('.language-wrapper').addClass("open");
        }, function () {
            $('.language-wrapper').addClass("closing");
            timeOut_1 = setTimeout(function () {
                $('.language-wrapper').addClass("close");
                setTimeout(function () { $('.language-wrapper').removeClass("open closing close"); }, 400);
            }, 150);
        });
    }
    else {
        $('.language-wrapper').on("click", function (e) {
            $('.language-wrapper').find(".language").toggleClass("m-open");
        });
    }
    $("body").on("click", ".tabulation .header a", function (e) {
        e.preventDefault();
        $("#explore.has-tabulator").attr("data-current", $(e.currentTarget).attr("href").replace("#", ""));
    });
    var elm = $(".tabulation .texts .content li");
    var elmNb = elm.length;
    var height = 0;
    elm.each(function (k, v) {
        var cHeight = $(v).children().outerHeight();
        if (cHeight > height)
            height = cHeight;
        if (elmNb == k + 1) {
            elm.css({ height: height });
        }
    });
    $(window).resize(function () {
        var height = 0;
        elm.each(function (k, v) {
            var cHeight = $(v).children().outerHeight();
            if (cHeight > height)
                height = cHeight;
            if (elmNb == k + 1) {
                elm.css({ height: height });
            }
        });
    });
    if ($("#map").length && $(window).width() < 420) {
        $('#map > .image').scrollLeft(100);
    }
    // $(".date").find("input").each((k, e) => {
    //     if ($(e).val() != "") $(e).addClass("filled");
    //     else $(e).removeClass("filled");
    // });
    // $(".date").find("input").on("click", (e) => {
    //     if ($(e.currentTarget).val() != "") $(e.currentTarget).addClass("filled");
    //     else $(e.currentTarget).removeClass("filled");
    // });
    if (Cookies.get("bannertop") === void 0) {
        $(".banner.top").fadeIn(250);
        $('.banner.top').children('a').on("click", function (e) {
            e.preventDefault();
            Cookies.set('bannertop', 'closed');
            $('.banner.top').fadeOut(250, function () {
                $("body").removeClass("has-banner-top");
            });
        });
    }
    else {
        $("body").removeClass("has-banner-top");
    }
    Site.init();
    if ($('.date-picker.start').length) {
        Site.eventPage();
    }
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']", function (e) {
        var elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            var posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    var lastScrollTop = 0;
    var scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 400) {
            $('#main-header').addClass('fixed');
        }
        else {
            $('#main-header').removeClass('fixed');
        }
        if (st > 250) {
            $('#main-header').addClass('scrolled');
            if (st > lastScrollTop) {
                $('#main-header').addClass('hide');
            }
            else {
                $('#main-header').removeClass('hide');
            }
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    $("body").on("click", "*[data-link]", function (e) {
        document.location = $(e.currentTarget).attr("data-link");
    });
    $("body").on("submit", "#newsletter form", function (e) {
        e.preventDefault();
        $("#newsletter button").addClass("wait");
        $.post("/api/newsletter/subscribe", { email: $("#newsletter-email").val(), language: $("#newsletter-language").val() }).done(function (data) {
            $("#newsletter button").removeClass("wait").addClass("success");
            setTimeout(function () {
                $("#newsletter-email").val("");
                $("#newsletter button").removeClass("success");
            }, 5000);
        });
    });
    $('body').on("click", ".explore-item .image a", function (e) {
        e.preventDefault();
    });
    $("body").on("click", ".glide__slide--active .explore-item", function (e) {
        document.location.href = $(e.currentTarget).attr("data-url");
    });
});
